import React, { Dispatch, SetStateAction } from 'react'
import { Container, ContentInLine, LoadingContainer, MessageError, SkeletonItem } from './styles'
import { AnatomopathologicalTestDetailsContent } from './content'
import { HealthProcedureDetails } from '../healthProcedureDetails'
import { ModalHeaderSkeleton } from '../ModalComponents/ModalHeader/Skeleton'
import { IHealthProcedures } from '~/interfaces'
import { useFetchAnatomopathologicalTest } from '~/hooks'
import { DataNotFound } from '~/components/shared'

interface Props {
  healthProcedure: IHealthProcedures
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
}

export const AnatomopathologicalTestDetails = ({ healthProcedure, showModal, setShowModal }: Props): JSX.Element => {
  const {
    data: anatomopathologicalTest,
    isLoading,
    error
  } = useFetchAnatomopathologicalTest({
    pathParams: { testId: healthProcedure.id }
  })

  const renderContent = () => {
    if (error)
      return (
        <MessageError>
          <DataNotFound text={error.message} />
        </MessageError>
      )
    if (anatomopathologicalTest)
      return <AnatomopathologicalTestDetailsContent anatomopathologicalTestData={anatomopathologicalTest} />
  }

  const loading = () => {
    return (
      <LoadingContainer>
        <ModalHeaderSkeleton />
        <SkeletonItem width={'100%'} height={'16px'} />
        <ContentInLine>
          <SkeletonItem width={'116px'} height={'16px'} />
          <SkeletonItem width={'204px'} height={'16px'} />
        </ContentInLine>
        <SkeletonItem width={'75%'} height={'16px'} />
        <SkeletonItem width={'92%'} height={'16px'} />
        <SkeletonItem width={'65%'} height={'16px'} />
      </LoadingContainer>
    )
  }

  return (
    <HealthProcedureDetails showModal={showModal} setShowModal={setShowModal} viewType="SideModal">
      <Container>{isLoading ? loading() : renderContent()}</Container>
    </HealthProcedureDetails>
  )
}
